import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { userCanRunSchedule } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { hasRunNowPermission } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { AppState } from '../../bootstrap/redux/state/AppState';
import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import { Messages } from '../../codegen/Localize';
import { IScheduleInfo } from '../types/IScheduleInfo';
import { scheduleRunNow } from './ScheduleMenuActions';

export const ScheduleRunNowAction: IEntityAction<IScheduleInfo, {}> = {
  name: EntityActionNames.SchedulesRunNow,
  translateName: Messages.runNow_action,
  isVisible: (targetItems: IScheduleInfo[], state: AppState) => {
    return targetItems.length > 0 && userCanRunSchedule(state, targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IScheduleInfo[]) => {
    return hasRunNowPermission(getAppStore().getState());
  },
  createReduxAction: (targetItems: IScheduleInfo[]) => scheduleRunNow(targetItems)
};
